import { BaseApi, ApiResponse } from "../utils/request";

export interface ReportErrorParams {
  url: string;
  content: string;
  version: string;
}

export class HomeApi extends BaseApi {
  async reportError(params: ReportErrorParams): Promise<ApiResponse<unknown>> {
    return this.post("/api/home/reportError", params, { alert: false });
  }
}

export const homeApi = new HomeApi();

export const reportError = (params: ReportErrorParams): void => {
  void homeApi.reportError(params).catch(() => {});
};
